import * as CONSTRUCTOR from '../../generate';

export const bankBranchPackageResponse = CONSTRUCTOR.FRAGMENT({
  name: 'BankBranchPackage',
  fragmentName: 'BankBranchPackageResponseFields',
  fields: `{
    id
    branch_id
    name
    description
    learn_more_url
    is_enabled
    created_at
    updated_at
  }`,
});

export const bankBranchPackagesListResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ListAllBankBranchPackagesResponse',
  fragmentName: 'BankBranchPackagesListResponseFields',
  fields: `{
    packages {
      id
      branch_id
      name
      description
      is_enabled
    }
    total_count
    limit
    offset
  }`,
});

export const bankersListResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ListBankersResponse',
  fragmentName: 'BankersListResponseFields',
  fields: `{
    bankers {
      id
      name
      preferred_name
      email
      mobile
      mobile_prefix
      bank_id
      bank_branch_id
    }
    total_count
    limit
    offset
  }`,
});
